import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './TextField.scss';
import commonStyles from 'styles/common.scss';

export default class TextField extends Component {
    isNotServiceKey = (key) => !['ArrowLeft', 'ArrowRight', 'Backspace'].includes(key);

    handleKeyDown = (event) => {
        const {accept, min, type} = this.props;
        if (type === 'number' && event.target.value < min) {
            event.preventDefault();
            return;
        }

        if (accept
            && typeof accept === 'object'
            && accept.test
            && this.isNotServiceKey(event.key)
            && !event.ctrlKey && !event.metaKey
            && !accept.test(event.key)
        ) {
            event.preventDefault();

            return;
        }

        if (event.key !== 'Enter') return;

        if (!this.props.onEnter) return;

        event.preventDefault();
        this.props.onEnter();
    };

    render() {
        const {
            className,
            type,
            placeholder,
            value,
            error,
            disabled,
            maxLength,
            onChange,
            onFocus,
            max,
            min,
            children,
        } = this.props;

        const inputClassName = classnames(styles.field, className, {
            [styles.highlightError]: Boolean(error),
        });

        const adornmentClassName = classnames(styles.adornmentContainer, commonStyles.flexCenterContent);

        // TODO: Do not use children as adornment and pass className to high level element
        if (!children) {
            return (
                <input
                    type={type}
                    className={inputClassName}
                    placeholder={placeholder}
                    value={value}
                    disabled={disabled}
                    maxLength={maxLength}
                    onChange={onChange}
                    onFocus={onFocus}
                    max={max}
                    min={min}
                    onKeyDown={this.handleKeyDown}
                    onClick={this.handleKeyDown}
                />
            );
        }

        return (
            <div className={styles.container}>
                <input
                    type={type}
                    className={inputClassName}
                    placeholder={placeholder}
                    value={value}
                    disabled={disabled}
                    maxLength={maxLength}
                    onChange={onChange}
                    onFocus={onFocus}
                    max={max}
                    min={min}
                    onKeyDown={this.handleKeyDown}
                    onClick={this.handleKeyDown}
                />
                <div className={adornmentClassName}>
                    {children}
                </div>
            </div>
        );
    }
}

TextField.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    disabled: PropTypes.bool,
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.number,
    min: PropTypes.number,
};

TextField.defaultProps = {
    type: 'text',
};



// WEBPACK FOOTER //
// ./src/components/controls/TextField.jsx